/* Giggles & Scribbles — blog product carousel: arrow scrolling (desktop) */
(function () {
  function wire(car) {
    if (car.dataset.gsWired) return;
    var track = car.querySelector('.gs-track');
    if (!track) return;
    car.dataset.gsWired = '1';
    var prev = car.querySelector('.gs-arrow--prev');
    var next = car.querySelector('.gs-arrow--next');
    function step() {
      var s = car.querySelector('.gs-slide');
      return s ? s.offsetWidth + 16 : 226;
    }
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step() * 2, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step() * 2, behavior: 'smooth' });
    });
  }
  function init() {
    document.querySelectorAll('.gsx .gs-carousel').forEach(wire);
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
